/**
 * Network protocol specifications and technical identifiers.
 * 
 * Shared constants for networking, streaming, and device protocols used across
 * cameras, appliances, and other network-enabled features.
 * 
 * These are internationally standardized technical specifications that should NOT be translated.
 * They remain in English across all locales to:
 * - Avoid translator confusion
 * - Maintain universal recognition in the tech industry
 * - Prevent breaking references to standard protocols
 */

export const PROTOCOL_NAMES = {
  HTTP: 'HTTP',
  HTTPS: 'HTTPS',
  RTSP: 'RTSP',
  RTMP: 'RTMP',
  RTSPS: 'RTSPS',
  UDP: 'UDP',
  SSL: 'SSL',
} as const;

export const AUTH_DIGEST_NAMES = {
  SHA256: 'SHA256',
  MD5: 'MD5',
} as const;


export const MEDIA_FORMAT_NAMES = {
  JPEG: 'JPEG',
  HLS: 'HLS',
  SLDP: 'SLDP',
} as const;


export const DEVICE_CONTROL_NAMES = {
  PTZ: 'PTZ',
} as const;


export const NETWORK_TERMS = {
  IP: 'IP',
  IP_ADDRESS: 'IP Address',
} as const;


export const NETWORK_PROTOCOL_SPECS = {
  PROTOCOLS: PROTOCOL_NAMES,
  AUTH_DIGESTS: AUTH_DIGEST_NAMES,
  MEDIA_FORMATS: MEDIA_FORMAT_NAMES,
  DEVICE_CONTROLS: DEVICE_CONTROL_NAMES,
  NETWORK_TERMS: NETWORK_TERMS,
} as const;


export type ProtocolName = typeof PROTOCOL_NAMES[keyof typeof PROTOCOL_NAMES];
export type AuthDigestName = typeof AUTH_DIGEST_NAMES[keyof typeof AUTH_DIGEST_NAMES];
export type MediaFormatName = typeof MEDIA_FORMAT_NAMES[keyof typeof MEDIA_FORMAT_NAMES];
export type DeviceControlName = typeof DEVICE_CONTROL_NAMES[keyof typeof DEVICE_CONTROL_NAMES];
export type NetworkTerm = typeof NETWORK_TERMS[keyof typeof NETWORK_TERMS];

